/* eslint-disable max-len */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-const */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-cond-assign */
import { Cookies } from 'react-cookie';
import { config } from '@app/config';
import COOKIES from '../consts/cookies';
import { isBrowser } from './renderContext';

interface CookieSetOptions {
  path?: string;
  expires?: Date;
  maxAge?: number;
  domain?: string;
  secure?: boolean;
  httpOnly?: boolean;
  sameSite?: boolean | 'none' | 'lax' | 'strict';
  encode?: (value: string) => string;
}

const { COOKIE_POLICY, TOS_PRIVACY } = COOKIES;

/**
 *
 * DOM Utilities. For handling common functions.
 *
 */
export default class DOM {
  static isDevEnv(): boolean {
    return config.ENVIRONMENT === 'development';
  }

  static getQueryParams() {
    if (typeof window !== 'undefined') {
      const { search } = window.location;

      return search.split(/\?|&/).reduce((coll, param) => {
        if (param.includes('=')) {
          const pair = param.split('=');
          coll[pair[0]] = pair[1];
        }

        return coll;
      }, {});
    }
  }

  static removeHistorySessionStorage() {
    if (typeof window === 'undefined') {
      return;
    }

    if (window?.sessionStorage) {
      const sessionKeys = Object.keys(window.sessionStorage);

      const histories = sessionKeys.filter((s) => s.startsWith('@@History'));

      histories.forEach((h) => {
        window.sessionStorage.removeItem(h);
      });
    }
  }

  static getLocalStorage(name: string) {
    const value = localStorage.getItem(name);

    if (!value) {
      return null;
    }

    return JSON.parse(value);
  }

  static setLocalStorage<T>(name: string, value: T) {
    localStorage.setItem(name, JSON.stringify(value));
  }

  static deleteLocalStorage(name: string) {
    localStorage.removeItem(name);
  }

  /**
   *
   * @param name
   */
  static getCookie<T>(name: string) {
    const cookies = new Cookies() || {};
    return cookies.get<T>(name);
  }

  static setCookie<T = any>(
    name: string,
    value: T,
    options: CookieSetOptions = {},
  ) {
    const cookieOptions: CookieSetOptions = {
      path: '/',
      sameSite: !this.isDevEnv() ? 'none' : undefined,
      secure: !this.isDevEnv(),
      ...options,
    };

    const cookies = new Cookies();
    const cookiePolicy = cookies.get(COOKIE_POLICY);
    const tosPrivacy = cookies.get(TOS_PRIVACY);

    if (cookiePolicy || tosPrivacy) {
      cookies.remove(name);
    }

    return cookies.set(name, value, cookieOptions);
  }

  static forceSetCookie<T = any>(
    name: string,
    value: T,
    options: CookieSetOptions = {},
  ) {
    const cookieOptions: CookieSetOptions = {
      path: '/',
      sameSite: !this.isDevEnv() ? 'none' : undefined,
      secure: !this.isDevEnv(),
      ...options,
    };

    const cookies = new Cookies();
    cookies.remove(name);

    return cookies.set(name, value, cookieOptions);
  }

  static delCookie(name) {
    const cookies = new Cookies();
    return cookies.remove(name, { path: '/' });
  }

  static scrollToTop = () => {
    if (isBrowser) {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }
  };

  static scrollToBottom = () => {
    if (isBrowser) {
      window.scrollTo({
        left: 0,
        top: document.body.scrollHeight,
        behavior: 'smooth',
      });
    }
  };

  static deleteHelpCenterAuthCookies() {
    const cookies = new Cookies();
    const allCookies = cookies.getAll();

    // if help center appSession cookie is too large
    // nextjs will break it into chunks and format it as
    // appSession.0, appSession.1, appSession.2, etc
    Object.keys(allCookies)
      .filter((cookie) => cookie.includes('appSession'))
      .map((cookie) => this.delCookie(cookie));

    this.delCookie('loggedIn');
  }
}
